module.exports = __webpack_public_path__ + "img/layout-icon.97cb546b.svg";